<template>
  <div id="app">
    <header class="clearfix">
      <h1><router-link to="/"><img src="logo.png"></router-link></h1>
      <nav>
        <router-link to="/prompt">Write</router-link>
        <router-link to="/promptGen">Generate a Prompt</router-link>
        <router-link to="/instructions">Instructions</router-link>
        <router-link to="/about">About</router-link>
      </nav>
    </header>

    <div id="mainContent">
      <router-view v-bind:user="user"/>
    </div>

    <footer>
      <div class="footerNav">
        <router-link to="/privacy">Privacy Policy</router-link>
      </div>
    </footer>
    <!-- TODO: add cookies opt-in -->
    <cookie-law>
      <div slot-scope="props">
        <p>This site asks you to participate in writing exercises. We use a cookie so that you can see you prior responses instead of storing any personal information or asking you to create an account.</p>
        <button class="skew" @click="props.accept"><span>I accept</span></button>
      </div>
    </cookie-law>
  </div>
</template>

<script type="text/javascript">
import CookieLaw from 'vue-cookie-law';

export default {
  data: function() {
    return {
      user: {}
    }
  },
  title: 'Under the Dog Star',
  components: { CookieLaw },
  created() {
    if (this.$cookies.isKey("user_session")) {
      this.user = this.$cookies.get("user_session");
      this.user.first_visit = false;
      this.$cookies.set('user_session', this.user);
    } else {
      this.$cookies.set('user_session', {
        uuid: this.$uuid.v1(),
        first_visit: true
      });
      this.user = this.$cookies.get("user_session");
    }
  }
}
</script>

<style media="screen" src="./styles/app.css"></style>
